// Hand-written extension of workflowApi (NOT auto-generated — see web-app/CLAUDE.md's codegen
// rule for why the *Api.ts files themselves are never hand-edited). RTK Query's supported way to
// add an endpoint to an existing createApi() instance from application code is injectEndpoints —
// this covers the one tenant-facing route (/api/v1/workflows/governance-actions) that has no
// platform_workflows OpenAPI-codegen counterpart yet.
import { workflowApi } from './workflowApi';

export interface GovernanceActionOption {
  action_key: string;
  description: string;
}

export interface GovernanceActionsResponse {
  success: boolean;
  message_code: number;
  data: GovernanceActionOption[];
}

export interface GovernanceOptionPreviewItem {
  value: string;
  label: string;
}

export interface GovernanceOptionsPreviewResponse {
  success: boolean;
  message_code: number;
  data: { available: boolean; options: GovernanceOptionPreviewItem[] };
}

export const workflowGovernanceApi = workflowApi.injectEndpoints({
  endpoints: (builder) => ({
    listGovernanceActions: builder.query<GovernanceActionsResponse, void>({
      query: () => '/api/v1/workflows/governance-actions',
    }),
    previewGovernanceOptions: builder.query<GovernanceOptionsPreviewResponse, { role: string }>({
      query: ({ role }) => `/api/v1/workflows/governance-options/preview?role=${encodeURIComponent(role)}`,
    }),
  }),
});

export const { useListGovernanceActionsQuery, usePreviewGovernanceOptionsQuery } = workflowGovernanceApi;
